import './TermOfUse.scss';
export default function TermOfUse({ }) {

  return (
  <div className="terms-of-use">
    <h1>Terms of Use – GenesisStake</h1>
    <p><strong>Last Updated:</strong> 09 April, 2025</p>
    <p>
    Welcome to GenesisStake.com (“we,” “our,” “us,” or “GenesisStake”).<br />
    These Terms of Use (“Terms”) govern your access to and use of our website (GenesisStake.com), subdomains, and related services (collectively, the “Site”).<br />
    By accessing or using the Site, you agree to these Terms. If you do not agree, you must stop using the Site immediately.
    </p>

    <h2>1. Nature of Services</h2>
    <ul>
    <li>GenesisStake is an independent sweepstakes and gambling comparison platform. We provide:</li>
    <ul>
      <li>Rankings, reviews, and comparisons of sweepstakes sites and gaming sites</li>
      <li>Information on promotions, Welcome Sweepstakes Rewards, and offers from third-party partners</li>
      <li>Links to third-party  platforms for informational and referral purposes</li>
    </ul>
    <li>We do not operate any sweepstakes sites, accept wagers, or process real-money gaming transactions.</li>
    </ul>

    <h2>2. Affiliate Disclosure</h2>
    <p>
    GenesisStake may receive commissions or compensation from featured partners if you click on their links or sign up through our Site.<br />
    These financial relationships may affect how and where offers appear but do not influence our editorial independence.
    </p>

    <h2>3. Eligibility</h2>
    <p>
    You must be 18 years of age or older (or the legal gambling age in your jurisdiction, whichever is higher) to use our Site.<br />
    It is your responsibility to ensure online gambling is legal in your location before accessing third-party sites.
    </p>

    <h2>4. Responsible Gambling</h2>
    <p>
    Gambling involves financial risk and can lead to addiction.<br />
    Play responsibly and only gamble with money you can afford to lose.<br />
    If you believe you have a gambling problem, contact a professional support service such as <a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer">BeGambleAware</a> or call the National Problem Gambling Helpline at <a href="tel:1-800-522-4700">1-800-522-4700</a> (U.S.).
    </p>

    <h2>5. No Warranties &amp; Limitation of Liability</h2>
    <ul>
    <li>All information on GenesisStake is provided “as is” for informational purposes only.</li>
    <li>We make no guarantees regarding:</li>
    <ul>
      <li>The accuracy, completeness, or timeliness of content</li>
      <li>The availability or legality of third-party s in your jurisdiction</li>
      <li>The outcome of any gambling activity</li>
    </ul>
    <li>GenesisStake will not be liable for any loss, damage, or harm arising from the use of our Site or third-party services.</li>
    </ul>

    <h2>6. Third-Party Websites</h2>
    <ul>
    <li>Our Site contains links to third-party websites (“Partner Sites”).</li>
    <li>We are not responsible for:</li>
    <ul>
      <li>The content, security, or privacy practices of Partner Sites</li>
      <li>Any transactions or disputes between you and a Partner Site</li>
    </ul>
    <li>Each Partner Site has its own terms and privacy policy, which you should review before engaging with them.</li>
    </ul>

    <h2>7. Intellectual Property</h2>
    <p>
    All content on GenesisStake — including text, graphics, logos, and design — is protected by copyright, trademark, and other intellectual property laws.<br />
    You may not copy, reproduce, or distribute our content without written permission.
    </p>

    <h2>8. User Conduct</h2>
    <p>When using our Site, you agree not to:</p>
    <ul>
    <li>Violate any applicable laws or regulations</li>
    <li>Engage in fraudulent or abusive activity</li>
    <li>Attempt to interfere with the operation or security of our Site</li>
    </ul>

    <h2>9. Changes to the Terms</h2>
    <p>
    We may update these Terms at any time.<br />
    If changes are significant, we will post a notice on our Site before they take effect. Continued use of the Site constitutes acceptance of the updated Terms.
    </p>

    <h2>10. Governing Law &amp; Dispute Resolution</h2>
    <p>
    These Terms are governed by the laws of the State of California, United States, without regard to conflict of law principles.<br />
    Any disputes shall be resolved exclusively in the state or federal courts located in Los Angeles County, California.
    </p>

    <h2>11. Contact Us</h2>
    <p>
    If you have questions about these Terms, contact us at:<br />
    <span role="img" aria-label="email">📧</span> <a href="mailto:support@genesisstake.com">support@genesisstake.com</a>
    </p>
  </div>
  )
}

